export const extname = name => /(\.\w+)$/.test(name) && RegExp.$1;



// WEBPACK FOOTER //
// ./lib/helpers/extname.js